<template>
  <div class="badges item">
    <div class="top">
      <div class="left">
        <div class="icon"></div>
        <div class="title"><span>Emblemas</span> grátis</div>
      </div>
      <div class="actions">
        <button :disabled="disableP" @click="getBad(prev)">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <button :disabled="disableN" @click="getBad(next)">
          <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
    <div class="content grid grid-cols-3 gap-2 max-h-[270px] min-h-[270px] !h-[270px] px-2">
      <template v-if="loading">
        <Sk v-for="i in 9" :key="i" w="100%" h="85px" rounded="rounded-lg" />
      </template>
      <template v-else>
        <template v-for="(_, index) in [...Array(9)]" :key="index">
          <div
            v-if="badges?.[index]?.code !== undefined"
            class="box animate__animated animate__headShake !w-full !h-[85px] !m-0"
            :style="{ backgroundImage: 'url(https://images.habblet.city/c_images/album1584/' + badges[index].code + '.gif)' }"
          >
            <ItemTip :title="badges[index]?.item || badges[index]?.code" top="-50%" />
            <RouterLink
              v-if="badges[index].id !== 0"
              :to="{ path: `noticia/${badges[index].id}/${badges[index].url}`, name: 'News', params: { id: badges[index].id, url: badges[index].url } }"
            />
          </div>
          <div v-else class="!h-[85px] !w-full"></div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import { getBadgesFree } from '@/services/api.js'
import ItemTip from '../usefulness/tooltip.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { onMounted, ref } from 'vue'

let badges = ref([])
let loading = ref(true)
let prev = ref(0)
let next = ref(0)
let disableP = ref(false)
let disableN = ref(false)

async function getBad(pag = 1) {
  loading.value = true
  try {
    const data = await getBadgesFree({ pag })
    badges.value = data.badges
    prev.value   = data.prev
    next.value   = data.next
    disableP.value = parseInt(data.prev) === 0
    disableN.value = data.next === 0
  } catch {
    badges.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => getBad())
</script>

<style scoped>
.badges {
  position: relative;
  width: 100%;
  height: 340px;
  background-color: #e6ebf1;
  @apply pt-2 pr-2 rounded-xl xl:rounded-none xl:rounded-r-xl;
}

.badges::before {
  content: '';
  width: 300%;
  height: 100%;
  position: absolute;
  top: 0;
  left: -300%;
  @apply xl:bg-[#E6EBF1];
}

.badges .top .icon {
  background-color: #2fc145;
  background-position: -36px -96px;
}

/*.badges .content {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}*/

.badges .content .box {
  position: relative;
  float: none;
  width: 100%;
  height: 85px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  background-color: #c3ced9;
  transition: all 0.4s ease;
  margin: 0;
}

.badges .content .box a {
  width: 100%;
  height: 100%;
  display: block;
}

/* .badges .content .box::after {
    content: '';
    position: absolute;
    float: left;
    width: 90px;
    height: 10px;
    border-radius: 12px 12px 0 0;
    background-color: #C3CED9;
    transition: all .4s ease;
    margin: 90px 0 0 0px;
} */

.badges .content .box:hover {
  background-color: #2fc145;
}
</style>
